import { render } from "./EmotionalEatingCourseIntro.vue?vue&type=template&id=cfb67f68"
import script from "./EmotionalEatingCourseIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./EmotionalEatingCourseIntro.vue?vue&type=script&setup=true&lang=js"

import "./EmotionalEatingCourseIntro.vue?vue&type=style&index=0&id=cfb67f68&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/survey/EmotionalEatingCourseIntro.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cfb67f68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cfb67f68', __exports__)) {
    console.log('reload')
    api.reload('cfb67f68', __exports__)
  }
  
  module.hot.accept("./EmotionalEatingCourseIntro.vue?vue&type=template&id=cfb67f68", () => {
    console.log('re-render')
    api.rerender('cfb67f68', render)
  })

}


export default __exports__